import { Typography } from "@mui/material";
import toast from "react-hot-toast";

const showToast = (type, message, defaultMessage) => {
    toast[type](
        <Typography textAlign="left">
            {message || defaultMessage}
        </Typography>
    );
};

const globalToast = {
    error: (message) => showToast("error", message, "Houve um erro ao tentar realizar esta ação! Entre em contato com o administrador."),
    success: (message) => showToast("success", message, "Ação realizada com sucesso!"),
};

export default globalToast;
